console.log('runder public quiz')


import { Card, Collapse, Empty, Spin, message, Button, Select, Space } from "antd";
import React, { useEffect, useRef, useState } from "react";
import QuizIcon from '@mui/icons-material/Quiz';
import Menu from "../../components/Menu/Menu";
import { BarChartOutlined, GlobalOutlined, PlusCircleTwoTone } from "@ant-design/icons";
import './QuizGenerator.scss';
import { useLocation, useNavigate } from "react-router-dom";
import { getQuizList } from "../../requests";
import { timeStampToDateTime } from "../../tools";
import { getPublicQuiz, getPublicQuizCorrectCount, getPublicQuizCount, getPublicQuizForTempUser, getPublicQuizIncorrectCount } from "../../requests/question";
import { useParams } from 'react-router-dom';



function Component(props) {

    const [messageApi, contextHolder] = message.useMessage();
    // const [quizzes, setQuizzes] = useState([]);
    const location = useLocation();
    const [spinning, setSpinning] = React.useState(false);
    const navigate = useNavigate();
    const [language, setLanguage] = useState('Chinese');
    const [total, setTotal] = useState(null);
    const [incorrect, setIncorrect] = useState(null);
    const [correct, setCorrect] = useState(null);
    const [user, setUser] = useState(()=>{
      const u = JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('tempUser'));
      return u;
    });
    const testListRef = useRef({});
    const { name } = useParams();
    const isFirstRef = useRef(true);

    // useEffect(()=>{
    //   const func = async ()=>{
    //     const listObj = await getPublicQuiz(user.user_id, language);
    //     testListRef.current = listObj;
    //   }
    //   func();
    // }, [])

    useEffect(()=>{
        const func = async ()=>{
          let tempUser;
          console.log('location.pathname', location.pathname)
          if(location.pathname === '/g1'){
            localStorage.setItem('isG1', 1);
          }
          if(!user){
            const res = await getPublicQuizForTempUser(language);
            testListRef.current = res.listObj;
            tempUser = res.tempUser;
            setUser(tempUser);
            localStorage.setItem('tempUser', JSON.stringify(tempUser));
          }else{
            testListRef.current = await getPublicQuiz(user.user_id, language);
          }
          const pList = [getPublicQuizCount(language), getPublicQuizCorrectCount(tempUser ? tempUser.user_id : user.user_id, language), getPublicQuizIncorrectCount(tempUser ? tempUser.user_id : user.user_id, language)];
          const resList = await Promise.all(pList);
          setTotal(resList[0].count);
          setCorrect(resList[1].count);
          setIncorrect(resList[2].count);
          
          localStorage.setItem('testsList', JSON.stringify(testListRef.current.normal));
          const testsList = testListRef.current.normal;

          if(isFirstRef.current){
            isFirstRef.current = false;
            const isG1 = localStorage.getItem('isG1') || JSON.parse(localStorage.getItem('isG1'));
            const isOffUser = localStorage.getItem('user') || JSON.parse(localStorage.getItem('user'));
            const isTempConvert = localStorage.getItem('tempConvert') || JSON.parse(localStorage.getItem('tempConvert'));
            
            if(isOffUser){
              localStorage.removeItem('isG1');
              localStorage.removeItem('tempUser');
              if(isTempConvert){
                navigate('/quiz', {
                  state: {
                    mode: 'test',
                    questionIdList: testsList[0].content,
                    attemp: testsList[0].attemp,
                    quiz_id: testsList[0].quiz_id,
                    backPath: '/public-test-list',
                  }
                });              }
            }else if(isG1){
              // navigate('/public-test-list');
              navigate('/quiz', {
                state: {
                  mode: 'test',
                  questionIdList: testsList[0].content,
                  attemp: testsList[0].attemp,
                  quiz_id: testsList[0].quiz_id,
                  backPath: '/public-test-list',
                }
              });
            }
          }
        }
        func();

        return (()=>{
          localStorage.removeItem('isG1')
        })
    }, [language])

    const handleLanChange = async (lan)=>{
      setLanguage(lan);
    }

    const handleTestClick = ()=>{
      navigate('/public-test-list', {
        // state: {
        //   mode: 'test',
        // }
      });
    }

    const handleMarathonClick = ()=>{
      navigate('/quiz', {
        state: {
            mode: 'study',
            questionIdList: testListRef.current.all[0].content,
            quiz_id: testListRef.current.all[0].quiz_id,
            attemp: testListRef.current.all[0].attemp,
            backPath: '/public-quiz',
        }
      })
    }

    const handleSimulatorClick = ()=>{
      messageApi.info('We are currently in the process of developing this feature.');
    }

    const quizListMergeToTheme = ()=>{
        /**
         * {
         *      theme_id: [quiz1, quiz2, ...],
         *      theme_id2: [quiz1, quiz2, ...],
         * }
         */
        let res = {};

        quizzes.forEach((ele, index) => {
            if(!res[ele.theme_id]){
                res[ele.theme_id] = [ele];
            }else{
                res[ele.theme_id].push(ele);
            }
        });
        /**
         * [
         *      {
         *          theme_id: id,
         *          theme_name: name,
         *          quizUnderTage: [quizzes]
         *      }
         * ]
         */
        const resList = [];
        for (const key in res) {
            if (Object.hasOwnProperty.call(res, key)) {
                const element = res[key]; // quizzes
                resList.push({
                    theme_id: key,
                    theme_name: res[key][0].theme_name,
                    quizUnderTag: element,
                })
            }
        }

        console.log('resList', resList)
        return resList; 
    }

    const goQuiz = async(e, quiz)=>{
        console.log('quiz', quiz);
        // e.preventDefault();
        // setOpen(true);
        // return;
        // if(theme){
            
        //     return;
        // }
        // setSpinning(true);
        // const questionList = await getQuizDetail(quizId, quizType);
        // setSpinning(false);
        navigate('/quiz', {
            state: {
                quiz_id: quiz.quiz_id,
                questionIdList: quiz.content,
                backPath: '/public-quiz',
            }
        });
    }


    return (
      <div className="bg-white container">
        {contextHolder}
        <div className="px-4 pt-4">
          <Menu/>
          <br/>
          <div className="flex justify-between items-center">
            <h1 className="text-2xl font-bold">G1 Ontario</h1>
            <Space>
              <GlobalOutlined style={{fontSize: '24px'}} className="text-gray-500" />
              <Select
                // defaultValue="ENG"
                style={{ width: 120 }}
                options={[
                  { value: 'English', label: 'ENG' },
                  { value: 'Chinese', label: 'CHN' },
                ]}
                value={language}
                onChange={handleLanChange}
              />
            </Space>
          </div>
          <div className="flex justify-between items-center my-2">
            <span className="text-sm font-light">{correct}/{total}</span>
            <span className="text-sm font-light">YOU'RE READY TO {Math.round((correct + incorrect) / total * 100)}%</span>
          </div>
        </div>
        <div className="flex justify-around bg-gray-100 p-4">
          <div className="text-center">
            <StarIcon className="text-blue-500" />
            <div className="text-sm">Favorites</div>
            <div className="font-semibold">0</div>
          </div>
          <div className="text-center">
            <XIcon className="text-blue-500" />
            <div className="text-sm">Mistakes</div>
            <div className="font-semibold">{incorrect}</div>
          </div>
        </div>
        {/* <div className="p-4">
          <Button onClick={handleSimulatorClick} className="bg-blue-500 text-white w-full py-4 rounded-lg flex items-center justify-center space-x-2">
            <StarIcon className="text-white" />
            <span>Unlock All Access, Ad-free</span>
            <ArrowDownIcon className="text-white" />
          </Button>
        </div> */}
        <div className="px-4 mt-4">
          <div className="grid grid-cols-1 gap-4">
          <Card className="bg-gray-100 p-4 rounded-lg text-center">
              <OptionIcon onClick={handleMarathonClick} className="text-blue-500 h-16 w-16 mx-auto" />
              <div className="mt-2 font-semibold">Study Mode</div>
            </Card>
            <Card className="bg-gray-100 p-4 rounded-lg text-center">
              <QuizIcon style={{fontSize:'4rem'}} onClick={handleTestClick} className="text-blue-500 h-16 w-16 mx-auto" />
              <div className="mt-2 font-semibold">Tests</div>
            </Card>
            {/* <Card className="bg-gray-100 p-4 rounded-lg text-center">
              <LocateIcon onClick={handleSimulatorClick} className="text-blue-500 h-16 w-16 mx-auto" />
              <div className="mt-2 font-semibold">Exam Simulator</div>
              <div className="text-sm text-gray-500 mt-1">Available in premium</div>
            </Card> */}
          </div>
        </div>
      </div>
    )
  }
  
  function ArrowDownIcon(props) {
    return (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 5v14" />
        <path d="m19 12-7 7-7-7" />
      </svg>
    )
  }
  
  
  function LocateIcon(props) {
    return (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="2" x2="5" y1="12" y2="12" />
        <line x1="19" x2="22" y1="12" y2="12" />
        <line x1="12" x2="12" y1="2" y2="5" />
        <line x1="12" x2="12" y1="19" y2="22" />
        <circle cx="12" cy="12" r="7" />
      </svg>
    )
  }
  
  
  function OptionIcon(props) {
    return (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 3h6l6 18h6" />
        <path d="M14 3h7" />
      </svg>
    )
  }
  
  
  function SettingsIcon(props) {
    return (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    )
  }
  
  
  function StarIcon(props) {
    return (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    )
  }
  
  
  function XIcon(props) {
    return (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
      </svg>
    )
  }

  export default Component;
// function PublicQuiz(porps){
//     const [messageApi, contextHolder] = message.useMessage();
//     const [quizzes, setQuizzes] = useState([]);
//     const [spinning, setSpinning] = React.useState(false);
//     const navigate = useNavigate();
//     const user = JSON.parse(localStorage.getItem('user'));
    
//     useEffect(()=>{
//         const func = async ()=>{
//             const list = await getPublicQuiz(user.user_id);
//             console.log('list', list);
//             setQuizzes(list)
//         }
//         func();
//     }, [])

//     const quizListMergeToTheme = ()=>{
//         /**
//          * {
//          *      theme_id: [quiz1, quiz2, ...],
//          *      theme_id2: [quiz1, quiz2, ...],
//          * }
//          */
//         let res = {};

//         quizzes.forEach((ele, index) => {
//             if(!res[ele.theme_id]){
//                 res[ele.theme_id] = [ele];
//             }else{
//                 res[ele.theme_id].push(ele);
//             }
//         });
//         /**
//          * [
//          *      {
//          *          theme_id: id,
//          *          theme_name: name,
//          *          quizUnderTage: [quizzes]
//          *      }
//          * ]
//          */
//         const resList = [];
//         for (const key in res) {
//             if (Object.hasOwnProperty.call(res, key)) {
//                 const element = res[key]; // quizzes
//                 resList.push({
//                     theme_id: key,
//                     theme_name: res[key][0].theme_name,
//                     quizUnderTag: element,
//                 })
//             }
//         }

//         console.log('resList', resList)
//         return resList; 
//     }

//     const goQuiz = async(e, quiz)=>{
//         console.log('quiz', quiz);
//         // e.preventDefault();
//         // setOpen(true);
//         // return;
//         // if(theme){
            
//         //     return;
//         // }
//         // setSpinning(true);
//         // const questionList = await getQuizDetail(quizId, quizType);
//         // setSpinning(false);
//         navigate('/quiz', {
//             state: {
//                 quiz_id: quiz.quiz_id,
//                 questionIdList: quiz.content,
//                 backPath: '/public-quiz',
//             }
//         });
//     }

//     return (
//         <div className='quiz' style={{height: '100vh', overflow: 'auto'}}>
//             {contextHolder}
//             <Spin spinning={spinning} fullscreen='true' />
//             <div className='container mt-5 d-flex justify-content-between'>
//                 <Menu/>
//                 <div className='d-flex align-items-center quiz-title' style={{marginLeft: '10px'}}>QUIZ</div>
//             </div>

//             <div className="quiz-container">
//                 <div className='quiz-content-container quiz-content-no-bgcolor quiz-content-title'>
//                     <span className="fs-5 fw-bold">Quiz Set</span>
//                 </div>
//                 <div className="quiz-content-container mh-30">
//                     {/* <span className="fs-5 fw-bold">Quiz Set</span> */}
//                     <div className='container'>
//                     <Collapse items={
//                             quizListMergeToTheme(quizzes).map((theme, index)=>{
//                                 console.log('theme.theme_name', theme.theme_name);
//                                 return {
//                                     key: index,
//                                     label: theme.theme_name, 
//                                     // extra: <span onClick={(e)=>{goQuiz(e, '', '', theme)}} >-></span>,
//                                     children: theme.quizUnderTag.map((q, i)=>{
//                                         console.log('q',q)
//                                         return <Card hoverable key={i}
//                                             title={<div className='d-flex justify-content-between'>
//                                                 <span>{q.title}</span>
//                                                 <span>{timeStampToDateTime(q.generate_time)}</span>
//                                             </div>}
//                                             bordered={true}
//                                             style={{marginBottom: '16px'}}
//                                             actions={[
//                                                 <><svg key="edit" onClick={(e)=>{goQuiz(e, q)}} xmlns="http://www.w3.org/2000/svg" width="100%" height="16" fill="currentColor" className="bi bi-pencil" viewBox="0 0 16 16">
//                                                     <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
//                                                 </svg></>,
//                                                 <BarChartOutlined key="barChart" onClick={()=>{messageApi.info('The feature is under development.')}}/>,
//                                             ]}
//                                         >
//                                                 <p>{q.description}</p>
//                                                 <br/>
                                                
//                                                 <div className='d-flex flex-column justify-content-between align-items-end'>
//                                                     <div style={{color: `${q.submit_id? 'black':'#ffc107'}`}}>
//                                                         {
//                                                             !q.submit_id ? <span>Unattempted Exercises</span> : 
//                                                                 <div>
//                                                                     Last submit: 
//                                                                     {/* <span style={{fontWeight: 'bold', marginRight: '10px'}}>{subObj[q.quiz_id]?.correct_count}</span> */}
//                                                                     <span>{timeStampToDateTime(q.submit_time || null)}</span>
//                                                                 </div>
//                                                         }
                                                    
                                                        
//                                                     </div>
//                                                 </div>
//                                         </Card>
//                                     })
//                                 }
//                             })
//                     }  onChange={()=>{}} />
//                     </div>
//                     {quizzes.length === 0 ? <div className='d-flex flex-column justify-content-center h-75'><Empty
//                         description={
//                         <span>
//                             You don't have any quiz.
//                         </span>
//                         }
//                         imageStyle={{ height: 100 }}
//                     ></Empty></div> : null}
//                 </div>
//             </div>
//         </div>
//     );

// }

// export default PublicQuiz;